import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import UserPermissionProxy from "../../utility/proxy/manager/permissionProxy/userPermissionProxy";
import { Box, CircularProgress, Tooltip } from "@mui/material";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import PersonIcon from "@mui/icons-material/Person";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import Constants from "../../utility/constants";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import Utility from "../../utility/utility";
import PageTitle from "../common/pageTitle";

const UserWithoutPermission = () => {
  const [data, setData] = useState([]);
  const [access, setAccess] = useState(false);
  const [errorSnackbar, seterrorSnackbar] = useState(false);
  const [
    userWithoutPermissionLoader,
    setUserWithoutPermissionLoader,
  ] = useState(false);

  const [filterValues, setFilterValues] = useState({});

  const getAllUserWithoutPermission = () => {
    setUserWithoutPermissionLoader(true);
    UserPermissionProxy.GetUserWithoutPermission((response) => {
      if (response) {
        const uniqueFilterValues = {
          designation: Utility.getDistinctOptions(response, "designation"),
          createdby: Utility.getDistinctOptions(response, "createdby"),
          city: Utility.getDistinctOptions(response, "location"),
          country: Utility.getDistinctOptions(response, "country"),
        };
        setFilterValues(uniqueFilterValues);
        setData(response);
        setUserWithoutPermissionLoader(false);
      } else {
        seterrorSnackbar(true)
        setUserWithoutPermissionLoader(false);
      }
    });
  };

  useEffect(() => {
    PageTitle("REPORT_PERMISSION_USERWITHOUTPERMISSION");
    checkPermission();
  }, []);

  const checkPermission = () => {
    let allowed = Constants.USER_PERMISSION.find(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.REPORT_PERMISSION_USERWITHOUTPERMISSION
    ) !== undefined
    if (!allowed) {
      setAccess(true)
      return <NoPermission />
    } else {
      getAllUserWithoutPermission();
    }
  }


  const initialColumns = () => [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
    },
    {
      field: "username",
      headerName: "USER",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "first_name",
      headerName: "FIRST NAME",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "middle_name",
      headerName: "MIDDLE NAME",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "last_name",
      headerName: "LAST NAME",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "designation",
      headerName: "DESIGNATION",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.designation : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "usertype",
      headerName: "TYPE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.usertype.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.USER_TYPE[params.value],
    },
    {
      field: "employeeid",
      headerName: "EMPLOYEE ID",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.country : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "createdby",
      headerName: "CREATED BY",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.createdby : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "created",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "deleted",
      headerName: "DELETED",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: (params) => {
        return params.value === false ? (
          <Box>
            <PersonIcon color="success" />
          </Box>
        ) : (
          <Box>
            <PersonOffIcon color="error" />
          </Box>
        );
      },
    },
    {
      field: "disabled",
      headerName: "DISABLED",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: (params) => {
        return params.value === false ? (
          <Box>
            <PersonIcon color="success" />
          </Box>
        ) : (
          <Box>
            <PersonOutlineOutlinedIcon color="error" />
          </Box>
        );
      },
    },
  ];

  const rows = data;
  const columns = initialColumns();

  return (
    <div>
      {
        access ? <NoPermission /> : (
          <Box px={1}>
            <CommonSnackbar
              show={errorSnackbar}
              message={Constants.APiFailErrorMessage}
              variant={"error"}
              autoHide={Constants.SnackBarCloseTimer}
              title={"Failed"}
              handleClose={() => seterrorSnackbar(false)}
            />
            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                width: "100%",
                position: "relative",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                height: '85vh'
              }}
            >
              <DataGridPro
                disableRowSelectionOnClick={true}
                sx={{
                  '& .MuiDataGrid-columnHeader': {
                    color: '#fff',
                    backgroundColor: 'grey',
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                    py: "4px",
                  },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                    py: "12px",
                  },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                    py: "18px",
                  },

                  fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                }}
                density="compact"
                slots={{ toolbar: GridToolbar }}
                rows={rows}
                columns={columns}
                loading={userWithoutPermissionLoader}
                getRowId={(row) => row.id}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns id, the other columns will remain visible
                      locationid: false,
                      id: false,
                    },
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />
              <Box style={{ position: "absolute", top: 5, right: "270px" }}>
                {userWithoutPermissionLoader ? (
                  <CircularProgress size="1rem" />
                ) : (
                  <Tooltip title="Reload List">
                    <RefreshOutlinedIcon
                      onClick={() => getAllUserWithoutPermission()}
                      color="primary"
                      fontSize="medium"
                      sx={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                )}
              </Box>
            </Box>
          </Box>
        )}
    </div>
  );
};

export default UserWithoutPermission;
